import { JSX, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { UserData, getProfile } from "./UserService";

function Profile(): JSX.Element {
	const { t } = useTranslation();
	const [userData, setUserData] = useState<UserData>();
	const [error, setError] = useState(false);

	useEffect(() => {
		getProfile()
			.then(setUserData)
			.catch(() => setError(true));
	}, []);

	const clearError = useCallback(() => setError(false), []);

	return (
		<>
			{error && (
				<Alert id="error-message" severity="error" onClose={clearError}>
					{t("loadProfileError")}
				</Alert>
			)}

			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={6} sm={3} md={2}>
					<Typography id="firstname-label" variant="subtitle1">
						{t("firstName")}
					</Typography>
					<Typography id="firstname-field" variant="body1">
						{userData?.firstName}
					</Typography>
				</Grid>
				<Grid item xs={6} sm={3} md={2}>
					<Typography id="lastname-label" variant="subtitle1">
						{t("lastName")}
					</Typography>
					<Typography id="lastname-field" variant="body1">
						{userData?.lastName}
					</Typography>
				</Grid>
				<Grid item xs={12} sm={4} md={3}>
					<Typography id="email-label" variant="subtitle1">
						{t("email")}
					</Typography>
					<Typography id="email-field" variant="body1">
						{userData?.email}
					</Typography>
				</Grid>
			</Grid>
		</>
	);
}

export default Profile;
